import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "28",
  fill: "none",
  viewBox: "0 0 24 28"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#AFB0B0",
      "fill-rule": "evenodd",
      d: "m22.32 20.627-.084.258c-1.294 3.963-5.418 6.854-10.309 6.975h-.637c-4.891-.12-9.016-3.012-10.31-6.975l-.083-.258 1.312-.634L0 13.25l2.555.23 1.283-6.315h2.037L11.608 0l5.733 7.165h2.038l1.282 6.314 2.556-.229-2.21 6.743zM11.205 27.23l.085.002h.637l.147-.005c4.475-.17 8.19-2.774 9.466-6.277l-1.308-.632 2.082-6.356-2.165.193-1.293-6.362h-1.824l-5.424-6.779-5.423 6.779H4.36l-1.292 6.362-2.165-.193 2.082 6.356-1.309.632c1.283 3.52 5.026 6.132 9.53 6.28",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#AFB0B0",
      d: "M11.29 27.232h.637l.147-.005.002-5.544 4.48-2.895-.476-.715-4.004 2.587v-5.608l4.495-3.182-.507-.694-3.988 2.823V8.645h-.869v5.354l-3.989-2.823-.506.694 4.495 3.182v5.608l-4.004-2.587-.476.715 4.48 2.895-.002 5.547z"
    }, null, -1)
  ]))]))
}
export default { render: render }